import { FormConfig, Text } from '@lbcamden/lib-react';
import { DateTime } from 'luxon';
import { z } from 'zod';

import { noteFieldStyles } from './CurrentResidents.styled';

export type CommonFormValues = z.infer<typeof commonFormSchema>;

export const commonFormSchema = z.object({
  note: z.string().min(3, 'Please include more detail'),
  pcfraReviewDate: z.union([z.iso.date().optional(), z.literal('')]),
});

export const commonFormConfig: FormConfig<CommonFormValues> = {
  fieldConfigs: {
    note: {
      css: noteFieldStyles,
      type: 'textarea',
    },
    pcfraReviewDate: {
      label: 'Date for review (optional)',
      type: 'date',
      inputProps: {
        min: DateTime.now().toISODate(),
      },
    },
  },
};

export const notifyReferrerMessage = (
  <Text css={(theme) => ({ marginTop: `-${theme.spacing(4)}` })}>
    If a referrer was recorded after the original assessment, they will be notified of this action.
  </Text>
);
